const monthsMapping: Record<string | number, string> = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
  "All year round": "All year round",
};

export const displayListOfMonths = (items: (number | string)[]): string => {
  const mapped = items.map((item) => monthsMapping[item]);
  if (mapped.length === 0) {
    return "";
  } else if (mapped.length === 1) {
    return mapped[0];
  } else if (mapped.length === 2) {
    return mapped.join(" and ");
  } else {
    return mapped.slice(0, -1).join(", ") + " and " + mapped[mapped.length - 1];
  }
};

// URL utility functions for handling spot slugs
export const createSpotSlug = (name: string, country: string, id: number | string): string => {
  // Create a URL-friendly slug: "alicante-spain-2"
  const slug = `${name.toLowerCase()}-${country.toLowerCase()}-${id}`;
  // Replace spaces and special characters with hyphens
  return slug
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/[^\w-]/g, "") // Remove special characters except hyphens
    .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, ""); // Remove leading/trailing hyphens
};

// Extract ID from slug (always the part after the last hyphen)
export const extractIdFromSlug = (slug: string): string | null => {
  if (!slug) return null;

  const parts = slug.split("-");
  const id = parts[parts.length - 1];

  // Validate that the last part is actually a number
  const numericId = parseInt(id, 10);
  return isNaN(numericId) ? null : numericId.toString();
};

// Validate if a slug matches the expected format
export const isValidSpotSlug = (slug: string): boolean => {
  if (!slug) return false;
  const id = extractIdFromSlug(slug);
  return id !== null;
};
